import { Pipe, PipeTransform, inject } from '@angular/core';

import { ExternalPriceFormatterService } from './external-price-formatter.service';
import { INativePrice } from './native-price';

@Pipe({
    name: 'msExternalPriceFormatter',
    standalone: true,
})
export class ExternalPriceFormatterPipe implements PipeTransform {
    private formatter = inject(ExternalPriceFormatterService);
    /**
     * Converts a price object of type `INativePrice` to an instance of NativePrice and format it with NativePriceFormatter, according to the specified user format.
     *
     * @param  nativePrice - The input price of type `INativePrice` that needs to be converted.
     * @returns  - The formatted price string.
     */
    transform(nativePrice: INativePrice | null | undefined): string {
        return this.formatter.format(nativePrice);
    }
}
